import { IConfig } from '@cian/config/shared';
import { IPromoModalConfig } from 'shared/types/newbuildingPromos';

const PROMO_MODAL_CONFIG_KEY = 'Newbuilding.PromoModalConfig';

export const getPromoModalConfig = (config: IConfig): IPromoModalConfig | null => {
  return config.get<IPromoModalConfig>(PROMO_MODAL_CONFIG_KEY);
};
